import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "DifficultySettingsContainer"
};
const _hoisted_2 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_3 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_4 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_5 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_6 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_7 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_8 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
const _hoisted_9 = {
  class: "wd100 border colFlex pd12 bothCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "boldFont"
      }, "舒尔特方格闪图", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("span", null, "闪烁时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.FlashDiamond.flashInterval,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.settings.FlashDiamond.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => $options.updateSetting('FlashDiamond'))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "boldFont"
      }, "打地鼠", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("span", null, "动画时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.WhackAMole.playInterval,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.settings.WhackAMole.playInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => $options.updateSetting('WhackAMole'))
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[24] || (_cache[24] = _createElementVNode("span", {
        class: "boldFont"
      }, "快速记忆", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.FastMemory.flashInterval,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.settings.FastMemory.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => $options.updateSetting('FastMemory'))
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[27] || (_cache[27] = _createElementVNode("span", {
        class: "boldFont"
      }, "808A消失", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.E808A.flashInterval,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.settings.E808A.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => $options.updateSetting('E808A'))
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[30] || (_cache[30] = _createElementVNode("span", {
        class: "boldFont"
      }, "E808E消失", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.E808E.flashInterval,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.settings.E808E.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = $event => $options.updateSetting('E808E'))
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[33] || (_cache[33] = _createElementVNode("span", {
        class: "boldFont"
      }, "摩斯密码消失", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossCopy.flashInterval,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.settings.MossCopy.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => $options.updateSetting('MossCopy'))
        }, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_cache[36] || (_cache[36] = _createElementVNode("span", {
        class: "boldFont"
      }, "摩斯密码消失4", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossMissing4.flashInterval,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.settings.MossMissing4.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = $event => $options.updateSetting('MossMissing4'))
        }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter pd12 box"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[39] || (_cache[39] = _createElementVNode("span", {
        class: "boldFont"
      }, "摩斯密码消失5", -1)), _createVNode(_component_el_row, {
        class: "bothCenter mt16"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "leftCenter"
        }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [_createElementVNode("span", null, "图例时长", -1)])),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "rightCenter"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "秒",
            modelValue: $data.settings.MossMissing5.flashInterval,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.settings.MossMissing5.flashInterval = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "mt16 bothCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = $event => $options.updateSetting('MossMissing5'))
        }, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode("更新难度设置")])),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  })]);
}